import { module } from 'stereomodularjs'

import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, A11y]);

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.params = {
            // Optional parameters
            loop: false,
            slidesPerView: '1.125',
            spaceBetween: 10,
            grabCursor: true,

            // If we need pagination
            pagination: {
                el: this.el.querySelector('.swiper-pagination'),
                clickable: true,
            },

            // Navigation arrows
            // navigation: {
            //     nextEl: this.el.querySelector('.swiper-button-next'),
            //     prevEl: this.el.querySelector('.swiper-button-prev'),
            // },

            // And if we need scrollbar
            // scrollbar: {
            //     el: this.el.querySelector('.swiper-scrollbar'),
            //     draggable: true,
            // },

            // a11y
            a11y: {
                prevSlideMessage: 'Image précédente',
                nextSlideMessage: 'Image suivante',
                paginationBulletMessage: "Aller à l'image {{index}}",
                firstSlideMessage: 'Première image',
                lastSlideMessage: 'Dernière image',
            },
        }

        this.typeSlider = this.el.dataset.type

        this.slider = new Swiper(this.el, this.params)

    }
}